// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3SgYm","controls":"styles_controls__3bJql","charLimit":"styles_charLimit__3sV-D","input":"styles_input__2JCdb","send":"styles_send__2LLrq"};